// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iEF7","colBig":"styles_colBig__10rgR","colSmall":"styles_colSmall__2xF8X"};